export const USE_CASE_MAX_LENGTH = 500;
export const USE_CASE_SOURCES = ["agent_context", "user_provided"] as const;
export type UseCaseSource = typeof USE_CASE_SOURCES[number];
export type IntegrationContext = { use_case: string; source: UseCaseSource; updated_at: string };

export function parseUseCase(value: unknown): { useCase: string; source: UseCaseSource } | null {
  if (!value || typeof value !== "object" || Array.isArray(value)) return null;
  const body = value as Record<string, unknown>;
  if (Object.keys(body).some(key => !["use_case", "source"].includes(key))) return null;
  if (typeof body.use_case !== "string" || body.use_case.length > USE_CASE_MAX_LENGTH) return null;
  const source = body.source ?? "user_provided";
  if (!USE_CASE_SOURCES.includes(source as UseCaseSource)) return null;
  if (/[\u0000-\u0008\u000b\u000c\u000e-\u001f]/.test(body.use_case)) return null;
  return { useCase: body.use_case.trim(), source: source as UseCaseSource };
}

export function readIntegrationContext(metadata: unknown): IntegrationContext | null {
  if (!metadata || typeof metadata !== "object") return null;
  const context = (metadata as Record<string, unknown>).integration_context;
  if (!context || typeof context !== "object") return null;
  const row = context as Record<string, unknown>;
  const parsed = parseUseCase({ use_case: row.use_case, source: row.source });
  if (!parsed || !parsed.useCase) return null;
  return { use_case: parsed.useCase, source: parsed.source, updated_at: typeof row.updated_at === "string" ? row.updated_at : "" };
}
